import { useState } from "react";

export default function AddUserModal({ onClose, onSubmit }) {
  const [form, setForm] = useState({ email: "", username: "", password: "", confirm: "" });
  const [errors, setErrors] = useState({});
  const [showPw, setShowPw] = useState({ password: false, confirm: false });

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });
  const togglePw = (field) => setShowPw((s) => ({ ...s, [field]: !s[field] }));

  const validate = () => {
    const e = {};
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email address.";
    if (form.username.length < 4) e.username = "Username must be at least 4 characters.";
    if (form.username.length > 25) e.username = "Username must not exceed 25 characters.";
    if (form.password.length < 12) e.password = "Password must be at least 12 characters.";
    if (form.password !== form.confirm) e.confirm = "Passwords do not match.";
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) return setErrors(e);
    onSubmit({ email: form.email, username: form.username, password: form.password });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl border border-gray-200 w-full max-w-md p-6 shadow-sm">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-base font-medium text-gray-900">Add user</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>

        {[
          { id: "email",    label: "Email address",   type: showPw.email    ? "text" : "email",    placeholder: "name@company.com" },
          { id: "username", label: "User name",        type: "text",                               placeholder: "john_doe" },
          { id: "password", label: "Password",         type: showPw.password ? "text" : "password", placeholder: "Min. 12 characters", toggle: true },
          { id: "confirm",  label: "Confirm password", type: showPw.confirm  ? "text" : "password", placeholder: "Re-enter password",  toggle: true },
        ].map(({ id, label, type, placeholder, toggle }) => (
          <div key={id} className="mb-4">
            <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
            <div className="relative">
              <input
                type={type}
                value={form[id]}
                onChange={set(id)}
                placeholder={placeholder}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {toggle && (
                <button
                  type="button"
                  onClick={() => togglePw(id === "confirm" ? "confirm" : "password")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"
                >
                  {showPw[id === "confirm" ? "confirm" : "password"] ? "Hide" : "Show"}
                </button>
              )}
            </div>
            {errors[id] && <p className="text-xs text-red-500 mt-1">{errors[id]}</p>}
          </div>
        ))}

        <div className="flex gap-2 mt-6">
          <button onClick={onClose} className="flex-1 py-2 text-sm border border-gray-200 rounded-lg text-gray-500 hover:bg-gray-50">
            Cancel
          </button>
          <button onClick={handleSubmit} className="flex-[2] py-2 text-sm font-medium border border-gray-200 rounded-lg hover:bg-gray-50">
            Create user
          </button>
        </div>
      </div>
    </div>
  );
}
